import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";

export default function PublicLayout() {
  const { pathname } = useLocation();
  const isCover = pathname === "/";
  return (
    <div className={isCover ? "bg-[#2B2B2B]" : "bg-[#F9FAFB]"}>
      <Navbar />
      <main className={isCover ? "" : "pt-16"}>
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
